import React, { useState, useEffect } from 'react';
import '../assets/styles/App.scss';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga';

import Header from '../sections/header';
import Intro from '../sections/intro';
import Commitments from '../sections/commitment';
import Stats from '../sections/stats';
import Segments from '../sections/segments';
import NotFound from './notFound';
import Slider from '../sections/slider';
import LinkSection from '../sections/linkSection';
import Quote from '../sections/quote';
import Progress from '../sections/progress';
import Footer from '../sections/footer';



import locales from '../locales/locales';
import commitments from '../locales/commitments';
import intro from '../locales/intro';
import quote from '../locales/quote';
import segments from '../locales/segments';
import stats from '../locales/stats';
import slider from '../locales/slider';
import progress from '../locales/progress'
import linkSection from '../locales/linkSection';

import logoCBCRC from "../assets/svg/cbc-radio-canada-white-blanc.svg";



const TRACKING_ID = "UA-398145-71";
ReactGA.initialize(TRACKING_ID);

function MainContent() {


    const [, setLang] = useState();
    var currentLang = locales.getLanguage();

    // useEffect(() => {

    //     // if (window.location.pathname === "/fr") {
    //     //     locales.setLanguage('fr');
    //     //     commitments.setLanguage('fr');
    //     //     intro.setLanguage('fr');
    //     //     quote.setLanguage('fr');
    //     //     segments.setLanguage('fr');
    //     //     stats.setLanguage('fr');
    //     //     slider.setLanguage('fr');
    //     //     progress.setLanguage('fr');
    //     //     linkSection.setLanguage('fr');


    //     //     setLang({});
    //     // }

    //     // else if (window.location.pathname === "/en") {
    //     //     locales.setLanguage('en');
    //     //     commitments.setLanguage('en');
    //     //     intro.setLanguage('en');
    //     //     quote.setLanguage('en');
    //     //     segments.setLanguage('en');
    //     //     stats.setLanguage('en');
    //     //     slider.setLanguage('en');
    //     //     progress.setLanguage('en');
    //     //     linkSection.setLanguage('en');



    //     //     setLang({});
    //     // }
    //     ReactGA.pageview(window.location.pathname + window.location.search);
    // }, []);

    locales.setLanguage('fr'); commitments.setLanguage('fr'); intro.setLanguage('fr'); quote.setLanguage('fr'); segments.setLanguage('fr'); stats.setLanguage('fr'); slider.setLanguage('fr'); progress.setLanguage('fr'); linkSection.setLanguage('fr');
    
    // locales.setLanguage('fr');
    //         commitments.setLanguage('fr');
    //         intro.setLanguage('fr');
    //         quote.setLanguage('fr');
    //         segments.setLanguage('fr');
    //         stats.setLanguage('fr');
    //         slider.setLanguage('fr');
    //         progress.setLanguage('fr');
    //         linkSection.setLanguage('fr');




    // const updateLang = () => {
    //     // console.log(currentLang)
    //     if (currentLang === "fr") {
    //         locales.setLanguage('en');
    //         commitments.setLanguage('en');
    //         intro.setLanguage('en');
    //         quote.setLanguage('en');
    //         segments.setLanguage('en');
    //         stats.setLanguage('en');
    //         slider.setLanguage('en');
    //         progress.setLanguage('en');
    //         linkSection.setLanguage('en');


    //         setLang({});
    //     }
    //     else if (currentLang === "en") {
    //         locales.setLanguage('fr');
    //         commitments.setLanguage('fr');
    //         intro.setLanguage('fr');
    //         quote.setLanguage('fr');
    //         segments.setLanguage('fr');
    //         stats.setLanguage('fr');
    //         slider.setLanguage('fr');
    //         progress.setLanguage('fr');
    //         linkSection.setLanguage('fr');


    //         setLang({});
    //     }
    // }

    return (

        <>
            <Router>

                <Switch>
                    <Route exact path={["/site/edi/fr", "/site/edi/en", "/site/edi/", "/site/edi/fr/index.html", "/site/edi/en/index.html"]}>
                        <Helmet>
                            <html lang={locales.general.currentLang.toLowerCase()} />
                            <title>{locales.seo.title}</title>
                            <meta name="description" content={locales.seo.description} />
                            <link rel="icon" href="https://site-cbc.radio-canada.ca/site/edi/favicon.ico" />

                            <meta charset="utf-8" />
                            <meta name="author" content="CBC/Radio-Canada" />
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0, minimum-scale=1.0" />
                            <meta name="theme-color" content="#0032FF" />


                            <meta property="og:title" content={locales.seo.title} />
                            <meta property="og:description"
                                content={locales.seo.description} />
                            <meta property="og:image"
                                content="https://site-cbc.radio-canada.ca/site/notok/images/notok-facebook-twitter-instagram-1200x630.jpg" />
                            <meta property="og:url"
                                content="https://notok.cestassez.ca" />
                            <meta property="og:type" content="website" />

                            <meta name="twitter:title" content={locales.seo.title} />
                            <meta name="twitter:description"
                                content={locales.seo.description} />
                            <meta name="twitter:image"
                                content="https://site-cbc.radio-canada.ca/site/notok/images/notok-facebook-twitter-instagram-1200x630.jpg" />
                            <meta name="twitter:card" content="summary_large_image" />


                            <meta property="og:site_name" content={locales.seo.title} />
                            <meta name="twitter:image:alt" content={locales.seo.title} />



                            <link rel="apple-touch-icon" sizes="120x120"
                                href="https://site-cbc.radio-canada.ca/site/edi/favicon-gem-rose192x192.png" />

                            <link rel="apple-touch-icon" sizes="152x152"
                                href="https://site-cbc.radio-canada.ca/site/edi/favicon-gem-rose192x192.png" />

                            <link rel="apple-touch-icon" sizes="167x167"
                                href="https://site-cbc.radio-canada.ca/site/edi/favicon-gem-rose192x192.png" />

                            <link rel="apple-touch-icon" sizes="180x180"
                                href="https://site-cbc.radio-canada.ca/site/edi/favicon-gem-rose192x192.png" />

                            <link rel="icon" sizes="192x192" href="https://site-cbc.radio-canada.ca/site/edi/favicon-gem-rose192x192.png" />

                            <link rel="icon" sizes="128x128" href="https://site-cbc.radio-canada.ca/site/edi/favicon-gem-rose192x192.png" />




                        </Helmet>
                        <div className="bgBlack"></div>
                        <div className="menu">
                            <div className="container">
                                <a href="https://cbc.radio-canada.ca" target="_blank" rel="noreferrer"><img src={logoCBCRC} alt="CBC/Radio-Canada logo" className="logo" /></a>
                                <nav>
                                    <button className="langSwitch eMedium bt-noir"><a className="bt-noir" href="https://site-cbc.radio-canada.ca/site/edi/en/index.html">{locales.general.lang}</a></button>

                                    {/* <Link to={"/" + locales.general.lang.toLowerCase()}><button className="langSwitch eMedium bt-noir" onClick={updateLang}>{locales.general.lang}</button></Link> */}
                                </nav>
                            </div>
                        </div>

                        <section className={locales.general.currentLang.toLowerCase() + "Active"}>
                            <div className="card no-border eMedium">
                                <Header />
                                <Intro />
                                <Quote />
                                <Commitments />
                                <Segments />
                                <Stats />
                                <Progress />
                                <Slider />
                                <LinkSection />
                                <Footer />
                            </div>



                        </section>
                    </Route>

                    <Route path="*">
                        <Helmet>
                            <html lang={locales.general.currentLang.toLowerCase()} />
                            <title>{locales.general.notFound}</title>
                            <link rel="icon" href="https://site-cbc.radio-canada.ca/site/notok/images/favicon.ico" />
                        </Helmet>
                        <NotFound />
                    </Route>

                </Switch>

            </Router>


        </>


    )
}

export default MainContent;